import {
  createFileRoute,
  redirect,
  useNavigate,
  useRouter,
} from '@tanstack/react-router';
import { toast } from 'sonner';

import { NewOrganizationForm } from '@/components/features/organization/new-organization-form';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { PublicPage } from '@/components/ui/layout/public-page';

export const Route = createFileRoute('/_public/organization/new')({
  component: NewOrganization,
  beforeLoad: ({ context }) => {
    const isAuthenticated = context.isAuthenticated;

    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }
  },
});

function NewOrganization() {
  const navigate = useNavigate();
  const router = useRouter();

  const handleSuccess = async () => {
    await router.invalidate({ sync: true });

    navigate({ to: '/dashboard' });
    toast.success('Connected');
  };

  return (
    <PublicPage.Layout>
      <PublicPage.Header />
      <Card className="w-full max-w-md mx-auto">
        <CardHeader>
          <CardTitle className="text-2xl">New Organization</CardTitle>
          <CardDescription>
            Create a new organization to get started
          </CardDescription>
        </CardHeader>

        <CardContent>
          <NewOrganizationForm onSuccess={handleSuccess} />
        </CardContent>
      </Card>
    </PublicPage.Layout>
  );
}
